export default "__VITE_ASSET__48d9bd38__"